<p-card class="item-card-border cursor-pointer" role="button" (click)="addOrEditBankAccount()" (keydown.enter)="addOrEditBankAccount()" (keydown.space)="addOrEditBankAccount()" tabindex="0">
    <div class="flex flex-row justify-content-between flex-wrap">
        <p class="pl-0 text-blue-700 flex align-items-center gap-2 m-0 font-medium">
            <i class="pi pi-plus"></i>
            {{ label || 'Bank account' }}
        </p>
        <div class="flex flex-row gap-1 justify-content-end mr-2 align-items-center">
            <i class="pi pi-building-columns"></i>
        </div>
    </div>
</p-card>
